import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const FacilitiesPage = () => (
  <Layout>
    <SEO title="Facilities | Preet Hospital" />
    <h1>Facilities</h1>
    <p>We provide world class facility for,</p>
    <ul>
      <li>OPD and specialized clinics</li>
      <li>Procedures and Surgical Operations</li>
      <li>Indoor and intensive care</li>
    </ul>
    <p>Specialised treatment is provided for a wide variety of conditions including:</p>
    <ul>
      <li><p><b>Antenatal Clinic (for pregnant ladies)</b></p>
        <p>Care of pregnant ladies from conception to delivery. The pregnant lady visits the OPD usually every 15 days or earlier for a checkup.</p>
        <p>All problems of pregnancy such as excessive vomiting, pain, bleeding, decreased movements etc are investigated and treated.</p>
        <p>All facilities such as vaccination, ultrasound, genetic counselling and delivery planning are provided in house.</p>
        <p>Special attention and care is provided in case any risk factor is detected.</p>
      </li>
      <li><p><b>High risk pregnancy care</b></p>
        <p>Care of special pregnancies in case of twins, hypertension, immunologic disease, thyroid disease, diabetes, heart disease, preterm labour, cervical incontinence, Rh incompatibility and bad obstetric history are dealt with on OPD basis as well as admitted patients in the High Risk Pregnancy Unit.</p>
        <p>Delivery whether vaginal or operative is planned in a scientific manner and in consultation with the family so as to get the best outcome for the mother and the baby.</p>
      </li>
      <li><p><b>Normal Delivery</b></p>
        <p>A delivery will be normal or operative is decided on the basis of strict clinical criteria and guidelines. The same is discussed with the pregnant lady and her family.</p>
        <p>The labour is closely monitored with reference to the condition of the mother, progress of labour and condition of the baby.</p>
        <p>Continuous foetal monitoring using electronic foetal monitor is used to assess the foetal condition.</p>
        <p>The delivery is conducted in a very pleasant and comfortable environment of the labour suit.</p>
        <p>The gynaecologist and paediatrician are in attendance during a normal delivery while an anaesthesiologist is on call in case required in an emergency.</p>
      </li>
      <li><p><b>Instrumental delivery</b></p>
        <p>A vacuum or forceps may be required to assist the delivery in case any undue delay, added risk or deteriorating foetal condition.</p>
      </li>
      <li><p><b>Painless delivery by Epidural Anaesthesia</b></p>
        <p>Though the birth of the baby is a normal physiologic process, some ladies opt for a painless delivery. The procedure consists of placement of a fine catheter in the Epidural space of the spine and injecting of small amounts of drug through it. The procedure requires intense monitoring for any side effects for the mother or the baby.</p>
      </li>
      <li><p><b>Caesarean Delivery</b></p>
        <p>An operative delivery is required in some cases for foetal or maternal reasons.</p>
        <p>Operation theatre facility is provided right next to the labour suit so that no time is lost from decision making to the delivery of the baby.</p>
        <p>The operation theatre is equipped with all facilities such as electronic monitoring and anaesthesia machine.</p>
      </li>
      <li><p><b>Obstetric emergencies</b></p>
      </li>
      <li><p><b>Ectopic pregnancy</b></p>
        <p>The occurrence of pregnancy in an abnormal location, usually in the fallopian tube.  It requires immediate intervention by medicines or by surgery.</p>
      </li>
      <li><p><b>Cervical Incompetence</b></p>
        <p>The dilatation of cervix which may lead to expulsion of the pregnancy sac and a miscarriage. It requires immediate management with medicines and surgery to avoid a loss of pregnancy.</p>
      </li>
      <li>
        <p><b>Preterm Labour</b></p>
        <p>The occurrence of uterine contractions before the maturity of the foetus leading to birth of a premature baby. This may require the patient to be admitted to the High Risk Pregnancy Unit for intensive monitoring and management.</p>
      </li>
      <li>
        <p><b>Uterine rupture</b></p>
        <p>Rupture of the uterus may occur in previous scarred uterus or during strong contractions in a normal pregnant uterus. It requires a life-saving surgery at the earliest.</p>
      </li>
      <li>
        <p><b>Ante-partum Haemorhage</b></p>
        <p>It may be due to Accidental haemorhage  in hypertensive patients or due to a low lying placenta (Placenta Previa). Requires an immediate management according to the condition of the patient.</p>
      </li>
      <li>
        <p><b>Post-partum haemorhage</b></p>
        <p>It may occur immediately after a delivery or several hours later. Either way it can be life threatening and requires immediate management.</p>
      </li>
      <li>
        <p><b>Post Natal Care</b></p>
        <p>Women after normal or caesarean delivery require special care and counselling for their early recovery. Certain complications which may occur during this period are also avoided by providing good monitoring and care.</p>
      </li>
      <li>
        <p><b>Gynaecology OPD</b></p>
      </li>
      <li>
        <p><b>Excessive bleeding during periods</b></p>
        <p>Usually due to Fibroids, Adenomyosis or DUB.</p>
      </li>
      <li>
        <p><b>Irregular bleeding</b></p>
        <p>Bleeding other than during regular periods or irregular periods can be due to Fibroids, Adenomyosis, DUB or Uterine cancer.</p>
      </li>
      <li>
        <p><b>Excessive pain during periods</b></p>
        <p>Usually due to Endometriosis, Adenomyosis, Fibroids, Tubo-ovarian mass, Ovarian cyst, Pelvic infection (PID).</p>
      </li>
      <li>
        <p><b>Excessive discharge from vagina</b></p>
        <p>Usually due to Vaginal infections and sometimes due to Cervical or Uterine cancer.</p>
      </li>
      <li>
        <p><b>Chronic pelvic pain</b></p>
        <p>Due to Pelvic inflammatory disease, Tubo-ovarian mass</p>
      </li>
      <li>
        <p><b>Excessive hair on body</b></p>
        <p>Hirsutism may occur as a result of hormonal imbalance in adolescents or in later age.</p>
      </li>
      <li>
        <p><b>Excessive weight gain</b></p>
        <p>May be caused by hormonal imbalance and dietary habits in adolescent and older age groups.</p>
      </li>
      <li>
        <p><b>Adolescent issues</b></p>
        <p>Adolescent may need investigation for certain peculiar conditions like excessive pain during or without periods, excessive or too less periods, They may also present with Acne, Obesity, Hirsutism or Anorexia or need counselling about hygiene or contraception.</p>
      </li>
      <li>
        <p><b>Sexual issues</b></p>
        <p>May lead to psychological issues or an unstable marriage.</p>
      </li>
      <li>
        <p><b>Menopausal issues</b></p>
        <p>Though a physiologic phenomenon, it may be associated with Severe hot flushes, Sexual issues, Severe osteoporosis.</p>
      </li>
      <li>
        <p><b>Infertility</b></p>
        <p>May be due to the Female factor or Male Factor or both.</p>
        <p>It requires a systematic evaluation treatment of the cause.</p>
      </li>
      <li>
        <p><b>Urogynaecology</b></p>
        <p>Leakage of urine during coughing can be a very debilitating problem in women leading to loss of confidence.</p>
        <p>Leakage of urine due to a fistuala following a surgery or any other cause requires immediate attention and treatment.</p>
      </li>
      <li>
        <p><b>Gynaecological Cancer screening and treatment</b></p>
        <p>Gynaecological cancer can occur in the cervix, uterine body, ovaries, fallopian tubes, vagina or the vulva.</p>
        <p>Cervical cancer is the one which can be easily prevented by undergoing routine screening. Other cancers can also be detected early if the lady is evaluated by a gynaecologist.</p>
      </li>
      <li>
        <p><b>Cosmetic gynaecology</b></p>
        <p>Many ladies want to undergo cosmetic procedures such as Hymenoplasty, Labioplasty, Vaginoplasty and colporhaphy to boost their confidence and improve their sexual health.</p>
      </li>
      <li>
        <p><b>MTP Clinic</b></p>
        <p>Unwanted pregnancy due to any reason such as foetal congenital defect or failure of contraception requires a Medical Termination of Pregnancy at a registered MTP Clinic. MTP is done by using medicines in some cases and by a surgical procedure in others.</p>
        <p>Preet Hospital is Registered MTP Clinic for up to 20 weeks of pregnancy.</p>
      </li>
      <li>
        <p><b>Contraception</b></p>
        <p>The requirement may be a short term in case of adolescents or long term in married couples or even a permanent procedure for those who have completed their family.</p>
      </li>
    </ul>
    <p>The following Procedures and Surgeries are being performed routinely at Preet Hospital. All Gynaecology surgeries and done by specialized gynaecologic surgeon. </p>
    <ul>
      <li><b>Advanced Laparoscopic Surgery</b>
        <ul>
          <li>TLH (Total Laparoscopic Hysterectomy)</li>
          <li>LAVH (Laparoscopic Assisted Vaginal Hysterectomy)</li>
          <li>Myomectomy,</li>
          <li>Ovarian surgery for ovarian cyst
            <ul>
              <li>Oopherectomy,</li>
              <li>Ovarian cystectomy &</li>
              <li>Salpingo-oopherectomy</li>
            </ul>
          </li>
          <li>Endometriosis surgery such as Adhesiolysis, Cystectomy</li>
          <li>Sacrocolpopexy for Uterine prolapse and Vault prolapse</li>
          <li>Cervical circlage,</li>
          <li>Infertility surgery
            <ul>
              <li>Adhesiolysis</li>
              <li>Tubal continuity check and cannulation</li>
              <li>Tubal recanalisation,</li>
              <li>Endometriosis surgery</li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        <b>Operative Hysteroscopic Surgery</b>
        <ul>
          <li>Evaluation</li>
          <li>Biopsy</li>
          <li>Polypectomy</li>
          <li>Tubal Cannulation</li>
          <li>Myomectomy</li>
          <li>Synechiae removal</li>
          <li>Septum removal</li>
          <li>IUCD removal etc.</li>
        </ul>
      </li>
      <li>
        <b>Advanced Vaginal Surgery</b>
        <ul>
          <li>Non Descent Vaginal Hysterectomy</li>
          <li>Vaginal hysterectomy for prolapse</li>
          <li>Salpingectomy</li>
          <li>Oopherectomy</li>
          <li>Colporhaphy</li>
          <li>Sacro-colposuspension</li>
          <li>Fourth degree perineal tear</li>
          <li>LEEP</li>
          <li>Cervical electro/cryocautery</li>
        </ul>
      </li>
      <li>
        <b>Abdominal Surgery</b>
        <ul>
          <li>Hysterectomy</li>
          <li>Oopherectomy, Ovarian Cystectomy</li>
          <li>Myomectomy</li>
          <li>Tuboplasty</li>
          <li>Cancer Surgery</li>
          <li>Urinary Fistula surgery etc.</li>
        </ul>
      </li>
      <li>
        <b>Surgery for Gynae Cancer</b>
        <ul>
          <li>Cervical cancerUterine cancer</li>
          <li>Ovarian cancer</li>
          <li>Vulval and Vaginal Cancer Surgery</li>
        </ul>
      </li>
      <li>
        <b>Urogynaecology</b>
        <ul>
          <li>Stress incontinence</li>
          <li>Urinary fistula</li>
          <li>Pelvic repair surgeries</li>
        </ul>
      </li>
      <li>
        <b>Gynae Reconstructive and cosmetic surgery</b>
        <ul>
          <li>Vaginoplasty</li>
          <li>Colporhaphy</li>
          <li>Hymenoplasty</li>
          <li>Labioplasty</li>
          <li>Fourth Degree Perineal tear repair</li>
        </ul>
      </li>
      <li>
        <b>Normal delivery</b>
        <ul>
          <li>Vacuum/Forceps Delivery</li>
          <li>Painless Delivery)</li>
        </ul>
      </li>
      <li>
        <b>Caesarean Delivery</b>
      </li>
      <li>
        <b>High Risk Pregnancy Unit</b>
        <ul>
          <li>Eclampsia & PIH</li>
          <li>Ante partum bleeding</li>
          <li>Diabetes with pregnancy</li>
          <li>Pregnancy with Thyroid</li>
          <li>Twins pregnancy</li>
          <li>Electronic foetal  Monitoring</li>
        </ul>
      </li>
      <li>
        <b>Ultrasound Clinic</b>
        <ul><li>2D, 3D, 4D Ultrasound and Colour Doppler</li></ul>
      </li>
      <li>
        <b>Genetic Clinic</b>
        <ul>
          <li>Amniocentesis</li>
          <li>Chorionic Villous Sampling</li>
          <li>Sample for Karyotyping and Microarray examination</li>
          <li>Embryo reduction</li>
        </ul>
      </li>
      <li>
        <b>MTP Clinic</b>
        <ul><li>Registered MTP Clinic for up to 20 weeks of pregnancy to include cases in which foetal defect is found after 12 weeks.</li></ul>
      </li>
      <li>
        <b>Cancer Screening</b>
        <ul>
          <li>Pap’s smear</li>
          <li>HPV Screening</li>
          <li>Colposcopy</li>
          <li>LEEP, Cryo/electrocautery</li>
          <li>Vaccination against cancer</li>
        </ul>
      </li>
    </ul>
    <h3>Why Choose Us</h3>
    <p>At Preet Hospital we keep the patient’s concerns above all else and provide a world class treatment in a comfortable environment. This is possible because the doctors are highly qualified from the best of institutions in the country and have a nationwide experience having worked in several state of the art hospitals.</p>
    <p>For best results a Gynaecologic surgery should be done by a gynaecology surgeon. As per the rules laid down by The Medical Council of India a specialized surgery should be done by a specialist in that speciality only. In western countries and in renowned hospitals like PGI Chandigarh and AIIMS New Delhi a gynaecological surgery like a hysterectomy whether open, vaginal or laparoscopic is done only by a specialist in gynaecology only.</p>
    <p>Dr Manjit Singh Sidhu is highly respected and regarded as a Gynaecologic surgeon in the area. He is the President of the Bathinda Obstetrics and Gynaecology Society since 2012 till date.</p>
    <p>He is well known in the region as he has introduced many surgeries for the first time. He introduced Non Descent Vaginal Hysterectomy for the first time in Punjab in 1998 and did a record over 50 such cases in the year 1999.</p>
    <p>Similarly he has introduced the Vaginal Sacrocolpopexy and vaginal salpingo-oopherectomy in the region in 1998. He is also the first to do a Laparoscopic Sacrocolpopexy for vault prolapse in the region.</p>
    <p>He is also in the forefront in the area in Laparoscopic Hysterectomy.</p>
    <p>Dr Preeti Sidhu is well known in the region for the last about two decades for her professional handling of complicated cases in the most compassionate manner.</p>
    <p>Therefore if you want the best in patient-care for yourself, choose us.</p>
  </Layout>
)

export default FacilitiesPage
